import {Constants} from '../data/constants.js';

/**
 * Calculate the amount of XP for a specific level
 * @param lvl Level to calculate the XP for
 * @returns Xp for the given level
 */
export function getXPForLevel(lvl: number) {
    if (Constants.xpRewardType === 'exp') {
        /* Subtracting XP_INC to xp ensures we start at Level 1 */
        return Constants.xpRewardMP * 0.5 * (2 - lvl + lvl * lvl) - Constants.xpRewardMP;
    } else {
        // Ensure level 1 starts at 0 XP
        return Constants.xpRewardMP * (lvl - 1);
    }
}

/**
 * Caluculate the level for a given amount of XP
 * @param xp XP to calculate the level for
 * @returns the level for the given amount of XP
 */
export function getLevelForXP(xp: number) {
    if (Constants.xpRewardType === 'exp') {
        /* Adding XP_INC to xp ensures we start at Level 1 */
        return Math.floor(
            0.5 *
                (1 +
                    Math.sqrt(8 * ((xp + Constants.xpRewardMP) / Constants.xpRewardMP) - 7))
        );
    } else {
        // Adding 1 to ensure we start at Level 1
        return Math.floor(xp / Constants.xpRewardMP) + 1;
    }
}

/**
 * Calculate the amount of XP to give to the player for killing an enemy
 * @param lvl level of the killed enemy
 * @returns Amount of XP to give to the player for killing the enemy
 */
export function getXPForKill(lvl: number) {
    if (Constants.xpRewardType === 'exp') {
        return Math.ceil(Math.pow(lvl + 1, Constants.xpkillRewardExponent));
    } else {
        return Math.ceil(lvl * Constants.xpkillRewardExponent);
    }
}
